import { render, staticRenderFns } from "./AddExtendParamsDialog.vue?vue&type=template&id=0cd7d891&scoped=true"
import script from "./AddExtendParamsDialog.vue?vue&type=script&lang=js"
export * from "./AddExtendParamsDialog.vue?vue&type=script&lang=js"
import style0 from "./AddExtendParamsDialog.vue?vue&type=style&index=0&id=0cd7d891&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7d891",
  null
  
)

export default component.exports